/* tslint:disable */
/* eslint-disable */
/**
 * AgentAssistService
 * Agent Assist API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ModelString
 */
export interface ModelString {
    /**
     * 
     * @type {string}
     * @memberof ModelString
     */
    string: string;
}


/**
 * Check if a given object implements the ModelString interface.
 */
export function instanceOfModelString(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "string" in value;

    return isInstance;
}

export function ModelStringFromJSON(json: any): ModelString {
    return ModelStringFromJSONTyped(json, false);
}

export function ModelStringFromJSONTyped(json: any, ignoreDiscriminator: boolean): ModelString {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'string': json['string'],
    };
}

export function ModelStringToJSON(value?: ModelString | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'string': value.string,
    };
}

